import api from '../utils/api';

export async function listAgentChannels(agentId, { page = 1, perPage = 20 } = {}) {
  const params = { page, per_page: perPage };
  const { data } = await api.get(`/agents/${agentId}/channels`, { params });
  return data;
}

export async function listChannels({ page = 1, perPage = 50, agentId } = {}) {
  const params = { page, per_page: perPage };
  if (agentId) {
    params.agent_id = agentId;
  }
  const { data } = await api.get('/channels', { params });
  return data;
}

export async function getChannel(channelId) {
  const { data } = await api.get(`/channels/${channelId}`);
  return data;
}

export async function createChannel(payload) {
  const { data } = await api.post('/channels', {
    agent_id: payload.agentId,
    type: payload.type || 'whatsapp',
    name: payload.name,
    catalog_id: payload.catalogId || undefined,
    configurations: payload.configurations || {},
    delivery_url: payload.deliveryUrl || undefined,
    delivery_token: payload.deliveryToken || undefined,
  });
  return data;
}

export async function updateChannel(channelId, payload) {
  const { data } = await api.put(`/channels/${channelId}`, payload);
  return data;
}

export async function deleteChannel(channelId) {
  const { data } = await api.delete(`/channels/${channelId}`);
  return data;
}

export async function getAccountAvailableCatalogs() {
  const { data } = await api.get('/accounts/me/available-catalogs');
  return data;
}
